import { useEffect, useState } from 'react';

import { fg } from '@confluence/feature-gating';
import {
	createSingleQueryParamHook,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState.ts';
import { useSmartCreationModalActions } from '@confluence/smart-creation-modal-store/entry-points/smartCreationModalStore.tsx';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

const useOpenCreateParam = createSingleQueryParamHook('openCreateWithRovo');

export const useCreateWithRovoOpen = () => {
	const { isRovoLLMEnabled } = useSessionData();
	const isLicensed = useIsLicensed();
	const { setQueryParams } = useRouteActions();
	const { openModal } = useSmartCreationModalActions();
	const [hasSeen, setHasSeen] = useState(false);
	const shouldOpenCreate = useOpenCreateParam();

	useEffect(() => {
		if (!fg('aifc_create_enabled') || !isRovoLLMEnabled || !isLicensed) return;

		if (shouldOpenCreate === 'true' || shouldOpenCreate === 'atlassianNew') {
			const entryPoint = 'queryParam';
			const entryPointToAppend = shouldOpenCreate === 'true' ? '' : `-${shouldOpenCreate}`;
			openModal({ entryPoint: entryPoint + entryPointToAppend, spaceKey: '' });

			if (!hasSeen) {
				setHasSeen(true);
				// Clear query params after user has seen modal
				setQueryParams({ openCreateWithRovo: null });
			}
		}
	}, [shouldOpenCreate, setQueryParams, openModal, hasSeen, isRovoLLMEnabled, isLicensed]);
};
